// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__11PUT","inner":"Footer_inner__VekU-","nextIcon":"Footer_nextIcon__tHI5i","innerLeft":"Footer_innerLeft__2ciwB"};